import React, { Component } from "react";
import { Redirect, Link } from "react-router-dom";
import onClickOutside from "react-onclickoutside";
import { withTranslation } from "react-i18next";

class HeaderDropdown extends Component {
  state = {
    dropdownAcc: this.props.dropdownAcc,
    activeMenu: null,
    defaultMenu: null,
    userType: 0,
    initialName: this.props.initialName,
    hexaColor: this.props.hexaColor,
  };
  handleClickOutside = (evt) => {
    // ..handling code goes here...
    // console.log("outside click header Account ", evt);
    this.props.callbackFromParent(false);
    this.setState({ dropdownAcc: false });
  };
  dropdownAccClick = () => {
    this.setState({ dropdownAcc: !this.state.dropdownAcc });
  };
  handleClick = (e) => {
    this.setState({ activeMenu: e.target.innerHTML, defaultMenu: null });
  };
  componentDidMount() {
    const userMenu = localStorage.getItem("userMenu");
    // console.log("receive userMenu ", userMenu);
    this.setState({
      dropdownAcc: this.props.dropdownAcc,
      userType: this.props.userType,
      defaultMenu: userMenu,
    });
  }
  render() {
    const isAuth = this.props.isAuth;
    const name = this.props.name;
    const profileIcon =
      "http://placehold.jp/24/" +
      this.state.hexaColor +
      "/2e2e2e/50x50.png?text=" +
      this.state.initialName;
    if (isAuth === "0") {
      return <Redirect to={"/logout"} />;
    }

    return (
      <div className="pull-right">
        <div className="profile">
          <span
            className="dropdown-acc"
            onClick={() => {
              this.setState({ dropdownAcc: !this.state.dropdownAcc });
            }}
          >
            <span className="profile-name">{name}</span>
            <img className="profile-picture" src={profileIcon} alt="Jejakin" />
            <i className="fa fa-caret-down" aria-hidden="true"></i>
          </span>
          <div
            className={
              this.state.dropdownAcc ? "wrap-hover show" : "wrap-hover"
            }
          >
            <div className="wrap-hover-content">
              <Link
                to="/profile"
                className="dropdown-item"
                onClick={this.dropdownAccClick}
              >
                {this.props.t("HeaderDropdown.link_profil")}
              </Link>
              <Link
                to="/transaction/tree"
                className="dropdown-item"
                onClick={this.dropdownAccClick}
              >
                {this.props.t("HeaderDropdown.link_transaksi")}
              </Link>
              {this.state.userType === 1 ? (
                <a
                  href={process.env.REACT_APP_BUSINESS}
                  className="dropdown-item"
                  onClick={this.dropdownAccClick}
                >
                  {this.props.t("HeaderDropdown.link_kelolaBisnis")}
                </a>
              ) : (
                ""
              )}
              <Link to="/logout" className="dropdown-item">
                {this.props.t("HeaderDropdown.link_keluar")}
              </Link>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default withTranslation()(onClickOutside(HeaderDropdown));
